import { http, methods } from './config';

export const login = data => {
  const config = {
    method: methods.post,
    url: `/api/auth/login`,
    data,
    silent: true,
  };
  return http(config);
};

export const logout = () => {
  const config = {
    method: methods.post,
    url: `/api/auth/logout`,
  };
  return http(config);
};

export const forgotPassword = data => {
  const config = {
    method: methods.post,
    url: `/api/auth/forgot-password`,
    data,
    silent: true,
  };
  return http(config);
};

export const verifyResetCode = data => {
  const config = {
    method: methods.post,
    url: `/api/auth/verify-reset-code`,
    data,
    silent: true,
  };
  return http(config);
};

export const resetPassword = data => {
  const config = {
    method: methods.post,
    url: `/api/auth/reset-password`,
    data,
    silent: true,
  };
  return http(config);
};
